import * as types from '../actionTypes/auth'

let defaultState = {
  hasCheckedForUserToken: false,
  isAuthenticated: false,
  hasSessionTimedOut: false,
  username: '',
  roles: [],
  lobbyistId: null,
  changePasswordDetails: {}
}

const authReducer = (state = defaultState, action) => {
  if (action.type === types.SET_AUTHENTICATED_STATUS) {
    return {
      ...state,
      isAuthenticated: action.isAuthenticated
    }
  }
  else if (action.type === types.SET_USERNAME) {
    return {
      ...state,
      username: action.username
    }
  }
  else if (action.type === types.SET_ROLES) {
    return {
      ...state,
      roles: action.roles
    }
  }
  else if (action.type === types.SET_LOBBYIST_ID) {
    return {
      ...state,
      lobbyistId: action.lobbyistId
    }
  }
  else if (action.type === types.CHECKED_FOR_USER_TOKEN) {
    return {
      ...state,
      hasCheckedForUserToken: action.hasCheckedForUserToken
    }
  }
  else if (action.type === types.GET_CHANGE_PASSWORD_DETAILS) {
    return {
      ...state,
      changePasswordDetails: action.changePasswordDetails
    }
  }
  else if (action.type === types.SESSION_TIMED_OUT) {
    return {
      ...state,
      isAuthenticated: false,
      username: '',
      roles: [],
      lobbyistId: null,
      hasSessionTimedOut: true
    }
  }
  else if (action.type === types.LOGOUT) {
    return {
      ...state,
      isAuthenticated: false,
      username: '',
      roles: [],
      lobbyistId: null
    }
  }
  else if (action.type === types.CLEAR_SESSION_TIMED_OUT) {
    return {
      ...state,
      hasSessionTimedOut: false
    }
  }
  else {
    return {
      ...state
    }
  }
}

export default authReducer;


// WEBPACK FOOTER //
// ./src/reducers/auth.js